import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatRadioChange } from '@angular/material/radio';
import { Select } from '@ngxs/store';
import { isEqual } from 'lodash';
import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { EngineNodesState } from 'src/app/engine/state/nodes/engine.nodes.state';
import { QuestionSubmission } from 'src/app/quiz/models/question-submission.model';
import { QuizQuestionType } from 'src/app/quiz/models/quiz-question-type.enum';
import { QuizQuestion } from 'src/app/quiz/models/quiz-question.model';
import { QuizState } from 'src/app/quiz/state/quiz.state';

@Component({
  selector: 'app-view-quiz-question',
  templateUrl: './view-quiz-question.component.html',
  styleUrls: ['./view-quiz-question.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ViewQuizQuestionComponent),
      multi: true
    }
  ]
})
export class ViewQuizQuestionComponent implements OnInit, OnDestroy, ControlValueAccessor {
  
  @Select(EngineNodesState.getCheckedNodeIds)
  checkedNodesIds$: Observable<string[]>;

  @Select(QuizState.getActiveSubmission)
  activeSubmission$: Observable<QuestionSubmission>;

  @Input()
  get question(): QuizQuestion {
    return this._question;
  }
  set question(question: QuizQuestion) {
    this._question = question;
    this.initQuestionListeners();
  }

  
  @Input()
  get value(): string | string[] {
    return this._value;
  }
  set value(value: string | string[]) {
    this._value = value;
    this.onChange(value);
  }
  private _value: string | string[];
  private _question: QuizQuestion;

  disabled = false;
  QuestionType = QuizQuestionType;

  private ngUnsubscribe = new Subject();

  constructor(
    private changeRef: ChangeDetectorRef
  ) { }

  handleMultipleChoiceChange(change: MatRadioChange) {
    this.writeValue(change.value);
  }

  handleLabelAnatomyChanges(values: string[]) {
    this.writeValue(values);
  }

  ngOnInit() {}

  initQuestionListeners() {
    switch (this.question.type) {
      case QuizQuestionType.SelectAnatomy:
        this.initSelectAnatomyListeners();
        break;
      case QuizQuestionType.Instructions:
        this.initInstructions();
        break;
      default:
        break;
    }
  }

  initSelectAnatomyListeners() {
    // write selected objects
    this.checkedNodesIds$
      .pipe(
        distinctUntilChanged((a, b) => isEqual(a, b)),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((checkedNodesIds) => {
        this.writeValue(checkedNodesIds);
        this.changeRef.markForCheck();
      });
  }

  initInstructions() {
    setTimeout(() => {
      this.writeValue('-'); // Triggers correct validation
      this.changeRef.markForCheck();
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onChange(value: string | string[]) { }

  onTouched() { }

  registerOnTouched(fn: () => void): void {
      this.onTouched = fn;
  }

  registerOnChange(fn: (value: string) => void): void {
      this.onChange = fn;
  }

  writeValue(value: string | string[]): void {
    this.value = value;
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }


}
